import React, { useState } from 'react';

import { Alert } from 'rsuite';
import { AuthApi, UserApi } from 'services/api';
import Form from '../../components/Form/index';
import { Router } from 'utils/with-i18next';
import { compose } from 'redux';
import {createErrorStatusCodeHandler}  from 'utils/default-http-error-handler';

export function Auth({ isPopup, setformAction, mutateUser, userType }) {
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    confirm_password: '',
    signInType: userType,
    userType: userType,
  });

  const onFormSubmit = async event => {
    event.preventDefault();
    setLoading(true);

    AuthApi.signup({ ...formValue })
      .then(() => {
        if (!isPopup) {
          Router.push('/list-property');
        } else {
          UserApi.getCurrentUser().then(user => mutateUser(user));
        }
      }).catch(createErrorStatusCodeHandler("sign up", (error) =>{
        Alert.error(`User with that email already exists, try logging in!`, 5000);
      },(error) =>{
        setLoading(false);
      }));
  };

  return (
    <Form
      signup
      titleText="Let's get started"
      buttonText="Sign Up"
      belowButtonText={
        <>
          Already have an account! <strong>Login</strong>
        </>
      }
      belowButtonLink="/login"
      handleSubmit={onFormSubmit}
      isLoading={loading}
      onChangeFormValue={setFormValue}
      formValue={formValue}
      isPopup={isPopup}
      setformAction={setformAction}
    />
  );
}

export default compose(Auth);
